import { DOCUMENT, NgClass } from '@angular/common';
import { Component, input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState } from 'src/app/reducers';
import { logoutUser } from 'src/app/reducers/user/user.actions';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LANGUAGES } from 'src/app/shared/constants/languages';
import { LanguageSelectorComponent } from 'src/app/shared/components/language-selector/language-selector.component';

@Component({
  selector: 'resto-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    TranslocoPipe,
    LanguageSelectorComponent,
    NgClass,
  ],
})
export class FooterComponent {
  private ngrxStore = inject<Store<IState>>(Store);
  private document = inject<Document>(DOCUMENT);

  showLogout = input.required<boolean>();
  currentLang = input.required<keyof typeof LANGUAGES>();

  logOut(): void {
    this.ngrxStore.dispatch(logoutUser());
  }

  goBackToOrderTaking(): void {
    this.document.location.href = 'https://menu.menutech.com/login';
  }

  imprintUrl = {
    de: 'https://menutech.com/de/impressum',
    en: 'https://menutech.com/en/imprint',
    it: 'https://menutech.com/it/informazioni-legali',
    fr: 'https://menutech.com/fr/mentions-legales',
    es: 'https://menutech.com/es/aviso-legal',
  };
  privacyUrl = {
    de: 'https://menutech.com/de/datenschutz-bestellungen-software',
    en: 'https://menutech.com/en/privacy-notice-ordertaking-app',
    it: 'https://menutech.com/it/privacy-app-gestione-delle-comande',
    fr: 'https://menutech.com/fr/confidentialite-application-prise-de-commande',
    es: 'https://menutech.com/es/privacidad-aplicacion-toma-de-ordenes',
  };
  termsUrl = {
    de: 'https://menutech.com/de/allgemeine-geschaeftsbedingungen',
    en: 'https://menutech.com/en/terms-and-conditions',
    it: 'https://menutech.com/it/condizioni-generali',
    fr: 'https://menutech.com/fr/conditions-generales-dutilisation',
    es: 'https://menutech.com/es/terminos-y-condiciones-generales',
  };
}
